import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { PageLoader } from '@/components/ui';
import { useAuth } from '@/lib/auth';

/**
 * Gate for every authenticated route. The intended destination survives the
 * round trip through /login in two ways — router state and a `?next=` query —
 * so both an in-app redirect and a hard reload land back where the user was.
 */
export function RequireAuth() {
  const location = useLocation();
  const hydrated = useAuth((state) => state.hydrated);
  const authenticated = useAuth((state) => Boolean(state.user && state.tokens));

  if (!hydrated) return <PageLoader label="Restaurando sua sessão…" />;

  if (!authenticated) {
    const next = `${location.pathname}${location.search}`;
    return (
      <Navigate
        to={`/login?next=${encodeURIComponent(next)}`}
        replace
        state={{ from: location }}
      />
    );
  }

  return <Outlet />;
}

export default RequireAuth;
